module.exports = __webpack_public_path__ + "src/img/artist/artistpage8.svg?ddf3d7bf115bf8e6cdbad44d55f68461";


//////////////////
// WEBPACK FOOTER
// ./src/img/artist/artistpage8.svg
// module id = 126
// module chunks = 0